import { useState, createContext, useEffect } from "react";
import "./App.css";
import UserInterface from "./components/UserInterface";
import Scene from "./components/Scene/Scene";
import CanvasIcons from "./components/CanvasIcons/CanvasIcons";
import "./i18n";
import { useTranslation } from "react-i18next";

export const ProductContext = createContext({});
export const MountingContext = createContext({});
export const MobileContext = createContext({});

const MOBILE_DEVICES =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

function App() {
  const [currentProduct, setCurrentProduct] = useState(null);
  const [wall, setWall] = useState(null);
  const [currentConfiguration, setCurrentConfiguration] = useState("7300a");
  const [currentColor, setCurrentColor] = useState("0x222827");
  const [selectedWing, setSelectedWing] = useState("wingLeft");
  const [topMounting, setTopMounting] = useState(true);
  const [rightMounting, setRightMounting] = useState(true);
  const [bottomMounting, setBottomMounting] = useState(true);
  const [middleMounting, setMiddleMounting] = useState(true);
  const [leftMounting, setLeftMounting] = useState(true);
  const [documentDirection, setDocumentDirection] = useState("ltr");
  const [isCanvasOverlayActive, setIsCanvasOverlayActive] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const { i18n } = useTranslation();

  useEffect(() => {
    setDocumentDirection(i18n.dir());
  }, [i18n, i18n.language]);

  const toggleCanvasOverlay = () =>
    setIsCanvasOverlayActive(!isCanvasOverlayActive);

  const canvasOverlayClass = () => (isCanvasOverlayActive ? "" : "hidden");

  window.addEventListener("resize", () =>
    setIsMobile(
      MOBILE_DEVICES.test(navigator.userAgent) ||
        window.matchMedia("(max-width: 48rem)").matches
    )
  );

  return (
    <ProductContext.Provider
      value={{
        currentProduct,
        setCurrentProduct,
        wall,
        setWall,
        currentConfiguration,
        setCurrentConfiguration,
        currentColor,
        setCurrentColor,
      }}
    >
      <MountingContext.Provider
        value={{
          topMounting,
          setTopMounting,
          selectedWing,
          setSelectedWing,
          rightMounting,
          setRightMounting,
          bottomMounting,
          setBottomMounting,
          middleMounting,
          setMiddleMounting,
          leftMounting,
          setLeftMounting,
        }}
      >
        <MobileContext.Provider value={{ isMobile: isMobile }}>
          <div className="window-container">
            <div className="window-container__inner">
              <CanvasIcons />
              <div className="canvas-container">
                <Scene
                  productConfiguration={currentConfiguration}
                  productColor={currentColor}
                />
              </div>
              <div
                className={`canvas-container__overlay ${canvasOverlayClass()}`}
              ></div>
            </div>
            <UserInterface
              documentDirection={documentDirection}
              toggleCanvasOverlay={toggleCanvasOverlay}
            />
          </div>
        </MobileContext.Provider>
      </MountingContext.Provider>
    </ProductContext.Provider>
  );
}

export default App;
